import { render, staticRenderFns } from "./Assistant.vue?vue&type=template&id=94acea14&scoped=true"
import script from "./Assistant.vue?vue&type=script&lang=ts"
export * from "./Assistant.vue?vue&type=script&lang=ts"
import style0 from "./Assistant.vue?vue&type=style&index=0&id=94acea14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94acea14",
  null
  
)

export default component.exports